import WhatsappTemplate from "./WhatsappTemplate";

export { WhatsappTemplate };


// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsappTemplate/components/index.js